import dynamic from 'next/dynamic'
import { type FC } from 'react'

import { type PimProductV11 } from '@redteclab/api/clients/bully'

import { useGlobalConfigContext } from '../../../../global-config'
import { RECOMMENDATION_WIDGET_BUY_TOGETHER } from '../../../../recommendation'
import { type TENANT } from '../../../../tenant'
import { productAccessorStockStatusIsAvailable } from '../../../model/productAccessor/productAccessorStockStatusIsAvailable'
import { PRODUCT_TEMPLATES } from '../../../model/productTemplates'
import { recommendationAccessorIsExceptionFlagActiveInProduct } from '../../../model/recommendationAccessor/recommendationAccessorIsExceptionFlagActiveInProduct'
import { useProductPageContext } from '../../productPageContext'

const shouldRenderRecommendationWidgetBuyTogether = ({
  currentVariant,
  productTemplate,
  tenant,
}: {
  currentVariant: PimProductV11
  productTemplate: PRODUCT_TEMPLATES
  tenant: TENANT
}): boolean => {
  const isRx = productTemplate === PRODUCT_TEMPLATES.RX

  return !(
    isRx ||
    !productAccessorStockStatusIsAvailable(currentVariant) ||
    recommendationAccessorIsExceptionFlagActiveInProduct({
      area: RECOMMENDATION_WIDGET_BUY_TOGETHER,
      currentVariant,
      tenant,
    })
  )
}

const DynamicProductRecommendationWidgetBuyTogetherInner = dynamic(async () =>
  import('./ProductRecommendationAreaBuyTogether').then(
    (mod) => mod.ProductRecommendationWidgetBuyTogether,
  ),
)

export const DynamicProductRecommendationWidgetBuyTogether: FC = () => {
  const { currentVariant, productTemplate } = useProductPageContext()
  const { tenant } = useGlobalConfigContext()

  if (
    !shouldRenderRecommendationWidgetBuyTogether({
      currentVariant,
      productTemplate,
      tenant,
    })
  ) {
    return null
  }

  return <DynamicProductRecommendationWidgetBuyTogetherInner />
}
